import * as React from 'react';
import { IAsidePanelActionsSectionProps } from './types';
import './_AsidePanelActionsSection.scss';
import {
    CLASS_ASIDE_PANEL_ACTIONS_SECTION_TITLE
} from './constants';
import { AsidePanelContext } from '../AsidePanel/constants';

export function AsidePanelActionsSection ({
    children,
    isShow,
    title,
    titleButton,
    titleClassName = '',
    onClick,
}: IAsidePanelActionsSectionProps) {
    if (isShow === false) return null;

    const { isMobile } = React.useContext(AsidePanelContext);
    const content = <>
        <div
            className={`
                ${CLASS_ASIDE_PANEL_ACTIONS_SECTION_TITLE}
                ${onClick ? CLASS_ASIDE_PANEL_ACTIONS_SECTION_TITLE + '--action' : ''}
                ${titleClassName}
            `}
            onClick={onClick}
        >
            {title}
            {titleButton}
        </div>
        <div className={'aside-panel__actions-section-body'}>
            {children}
        </div>
    </>;

    return (
        isMobile
            ? <div className={'aside-panel__actions-section'}>
                {content}
            </div>
            : content
    );
};
